export default {
	es: {

		enlaces : {
			categoria : '/categoria',
			noticia : "/noticia",
			contacto : "/contacto",
			noticias : "/noticias",
			politica_privacidad : "/politica-de-privacidad",
			politica_cookies : "/politica-de-cookies",
			avisolegal : "/aviso-legal",
		},
		formulario : {
			nombre : "Nombre",
			nombre_apellidos : "Nombre y apellidos",
			apellidos : "Apellidos",
			email : "Email",
			mensaje : "Mensaje",
			fecha_nacimiento : "Fecha de nacimiento",
			dia : "Día",
			mes : "Mes",
			anyo : "Año",
			area_interes : "Área de su interés",
			trabaja_actualmente : "¿Trabaja actualmente?",
			si : "Si",
			no : "No",
			carta_presentacion : "Carta de presentacion",
			meses : {
				Enero : "Enero",
				Febrero : "Febrero",
				Marzo : "Marzo",
				Abril : "Abril",
				Mayo : "Mayo",
				Junio : "Junio",
				Julio : "Julio",
				Agosto : "Agosto",
				Septiembre : "Septiembre",
				Octubre : "Octubre",
				Noviembre : "Noviembre",
				Diciembre : "Diciembre"
			},
			archivo_adjunto : "Adjuntar archivo",
			adjuntar_cv : "Adjuntar CV",
			introduce_mail : "Introduce tu email",
			pais : "País",
			telefono : "Teléfono",
			he_leido : "He leído y acepto la",
			y_acepto : "política de privacidad",
			enviar : "Enviar",
			enviado : "Enviado",
		},
		meses : ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"]
	},
	en: {
		enlaces : {
			actualidad : '/news',
			sala_de_prensa : "/press-room",
			contacto : "/contact",
			trabaja_con_nosotros: "/work-with-us",
			politica_privacidad : "/privacy-policy",
			politica_cookies : "/cookies-policy",
		}
	}
}



// WEBPACK FOOTER //
// ./src/translations/index.js